import validate from "/home/runner/work/evangelist-platform/evangelist-platform/node_modules/nuxt/dist/pages/runtime/validate.js";
import amplitude_45global from "/home/runner/work/evangelist-platform/evangelist-platform/apps/creator-frontend/src/middleware/amplitude.global.js";
import check_45domain_45global from "/home/runner/work/evangelist-platform/evangelist-platform/apps/creator-frontend/src/middleware/checkDomain.global.js";
import manifest_45route_45rule from "/home/runner/work/evangelist-platform/evangelist-platform/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  amplitude_45global,
  check_45domain_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}